import React from 'react';
import styled, { css } from 'styled-components';
import { Stack } from '../../styles/Containers'
import { FullUI } from '../../redux/UI/ui.selectors';
import { setSpace, respondTo, Theme } from '../../styles/Theme'

const StyledMainBody = styled(Stack)`

    /* padding-left: ${setSpace(4)}; */
    /* ${props => (!props.open) ? css` padding-left:  ${setSpace(23)};` : ` padding-left: ${setSpace(60)};`}; */
    padding-left: 66px;
    ${props => (!props.open) ? css` padding-left: 66px;` : ` padding-left: 200px;`};
    
    ${respondTo('mobile', css`
        padding-top: 70px;
        /* padding-left: ${setSpace(4)} !important; */
        padding-left:0px;
        ${props => (props.open) ? css`position: fixed;` : ``};
    `)}
    // CAPTURE COLLAB GRADIENT
    &:before {
        content: " ";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 20vh;
        z-index: -1;
        opacity:0.25;
        background:linear-gradient(180deg,transparent,hsla(0,0%,95%,.29) 47.39%,${Theme.colors.base}),linear-gradient(90deg,#f9ddf1 .07%,#e5e1ff 16.73%,#daedff 34.48%,#e2f4e3 49.98%,#ebf5d8 66.12%,#faf2da 81.95%,#fbe5d8 99.9%);
    }
`


export const MainBody = ({ children }) => {

    const ui = FullUI();
    const open = (!ui.drawer) ? false : ui.drawer.open

    return (
        <StyledMainBody data-main-body width="100%" open={open}>{children}</StyledMainBody>
    )
}